import gql from "graphql-tag";

const NimasaAdminUsers = gql`
  query($count: Int, $page: Int) {
    GetNimasaAdminUsers(count: $count, page: $page) {
      data {
        id
        email
        user_name
        full_name
        created_at
      }
      paginatorInfo {
        count
        firstItem
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

const PortUsers = gql `
query($count: Int, $page: Int) {
    GetAllPortUsers(count: $count, page: $page) {
      data {
        id
        email
        user_name
        full_name
        created_at
      }
      paginatorInfo {
        count
        firstItem
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }`

const NimasaUsers = gql `
query($count: Int, $page: Int) {
    GetNimasaUsers(count: $count, page: $page) {
      data {
        id
        email
        user_name
        full_name
        created_at
      }
      paginatorInfo {
        count
        firstItem
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }`

const NimasaManagerUsers = gql `
query($count: Int, $page: Int) {
  GetNimasaManagers(count: $count, page: $page) {
      data {
        id
        email
        user_name
        full_name
        created_at
      }
      paginatorInfo {
        count
        firstItem
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }`

export default {
    NimasaAdminUsers,
    PortUsers,
    NimasaUsers,
    NimasaManagerUsers,
}
